import http from "@/settings/apiSettings"

class DrepturiModuleDataService {
    getModule(): Promise<any> {
        return http.clientAuth.get("/AUTH_DrepturiModule/GetModule");
    }

    save(data: any): Promise<any> {
        return http.clientAuth.post("/AUTH_DrepturiModule/AddModul", data);
    }

    update(id: string, data: any): Promise<any> {
        return http.clientAuth.patch(`/AUTH_DrepturiModule/UpdateModul/${id}`, data);
    }

    delete(id: string): Promise<any> {
        return http.clientAuth.delete(`/AUTH_DrepturiModule/DeleteModul/${id}`);
    }
}

export default new DrepturiModuleDataService();
